import { render, staticRenderFns } from "./FormReset.vue?vue&type=template&id=1168e2bc&"
import script from "./FormReset.vue?vue&type=script&lang=js&"
export * from "./FormReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports